import {Box, Pagination} from '@mui/material';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {getElevatorsByBuilding, getElevatorsByEntrance} from '../../actions';
import {Filters} from '../../components';
import ElevatorsTable from '../../components/CustomTables/ElevatorsTable';
import useFilters from '../../utils/useFilters';
import {usePagination} from '../../utils/utilities';

const ElevatorsTab = ({entrance}) => {
  const {id} = useParams();
  const dispatch = useDispatch();
  const {buildingById} = useSelector(s => s.buildings);
  const {entranceById} = useSelector(s => s.entrances);
  const {buildingElevators, entranceElevators, elevatorsLoading} = useSelector(
    s => s.elevators,
  );
  const filters = useFilters(val =>
    dispatch(
      !entrance
        ? getElevatorsByBuilding(id, val)
        : getElevatorsByEntrance(id, val),
    ),
  );
  const pagination = usePagination(
    !!entrance ? entranceElevators : buildingElevators,
    10,
  );

  const building = entrance ? {id: entranceById?.buildingId} : buildingById;

  useEffect(() => {
    pagination.onChange(null, 1);
  }, [buildingElevators, entranceElevators]);

  return (
    <>
      <Box position="absolute" zIndex={1}>
        <Filters m="0 !important" withSearch {...filters} />
      </Box>
      <ElevatorsTable
        elevators={pagination.dataToShow}
        loading={elevatorsLoading}
        building={building}
      />
      {!!pagination.count && pagination.count > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination {...pagination} />
        </Box>
      )}
    </>
  );
};

export default ElevatorsTab;
